module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-form-procedure.5fb2b0ab.png";